export type CompetitionFeed = "OCNC" | "KLAS";

export type CardData = {
  id: number;
  title: string;
  description: string;
};

export type CompetitionCopy = {
  feed: CompetitionFeed;
  gameName: string;
  competitionName: string;
  competitionLabel: string;
  raceLabelSingular: string;
  raceLabelPlural: string;
  raceLabelWithArticle: string;
  raceLabelPluralWithArticle: string;
  raceLabelWithIndefiniteArticle: string;
  raceLabelTitle: string;
  raceLabelPluralTitle: string;
  raceLabelNl: string;
  metaTitle: string;
  metaDescription: string;
  heroTitle: string;
  heroSubtitle: string;
  heroDescription: string;
  bannerTopline: string;
  bannerCountdownLine: string;
  bannerHeadline: string;
  bannerDescription: string;
  bannerBudgetLine: string;
  cards: CardData[];
};

const COMPETITION_COPY: Record<CompetitionFeed, CompetitionCopy> = {
  OCNC: {
    feed: "OCNC",
    gameName: "Tour de France, le jeu",
    competitionName: "Tour de France",
    competitionLabel: "le Tour de France",
    raceLabelSingular: "étape",
    raceLabelPlural: "étapes",
    raceLabelWithArticle: "l'étape",
    raceLabelPluralWithArticle: "les étapes",
    raceLabelWithIndefiniteArticle: "une étape",
    raceLabelTitle: "Étape",
    raceLabelPluralTitle: "Étapes",
    raceLabelNl: "etappe",
    metaTitle: "Tour de France, le jeu : un jeu de management cycliste",
    metaDescription:
      "Envie de vivre le Tour de France comme un véritable directeur sportif ? Composez votre formation idéale, gagnez des points selon les performances de vos coureurs et courez la chance de remporter de nombreux cadeaux.",
    heroTitle: "Tour de France, le jeu",
    heroSubtitle: "Construis ta dream team pour le Tour de France.",
    heroDescription:
      "Stel je droomteam samen, scoor punten en maak kans op prijzen per étape en in het algemeen klassement. Doe vandaag nog mee!",
    bannerTopline: "Stel jouw Tour de France-team samen!",
    bannerCountdownLine: "tot de volgende etappe begint!",
    bannerHeadline: "Stel gratis jouw Tour de France-team samen en win fantastische prijzen!",
    bannerDescription:
      "Stel je droomteam samen, scoor punten en maak kans op prijzen per étape en in het algemeen klassement. Doe vandaag nog mee!",
    bannerBudgetLine: "Stel jouw €100 miljoen budget wielerteam samen voor de Tour de France!",
    cards: [
      {
        id: 1,
        title: "Deviens directeur sportif",
        description: "Construis ton équipe de 15 coureurs avec un budget de 140 millions d'euros. Attention : maximum 3 coureurs de la même équipe !",
      },
      {
        id: 2,
        title: "Marque des points",
        description: "Les 20 premiers de chaque étape rapportent des points. Des bonus sont aussi offerts aux porteurs de maillots et au coureur le plus combatif !",
      },
      {
        id: 3,
        title: "Utilise ton Joker !",
        description: "Active ton Joker sur un coureur pour une étape : tous ses points seront doublés. Choisis le moment parfait pour tout faire basculer !",
      },
      {
        id: 4,
        title: "Défie tes amis",
        description: "Crée ou rejoins une ligue pour défier tes amis et vivre l'expérience à fond.",
      },
    ],
  },
  KLAS: {
    feed: "KLAS",
    gameName: "On connaît nos classiques, le jeu",
    competitionName: "Classiques",
    competitionLabel: "les Classiques",
    raceLabelSingular: "course",
    raceLabelPlural: "courses",
    raceLabelWithArticle: "la course",
    raceLabelPluralWithArticle: "les courses",
    raceLabelWithIndefiniteArticle: "une course",
    raceLabelTitle: "Course",
    raceLabelPluralTitle: "Courses",
    raceLabelNl: "course",
    metaTitle: "On connaît nos classiques, le jeu : un jeu de management cycliste",
    metaDescription:
      "Envie de vivre les Classiques comme un véritable directeur sportif ? Composez votre formation idéale, gagnez des points selon les performances de vos coureurs et courez la chance de remporter de nombreux cadeaux.",
    heroTitle: "On connaît nos classiques, le jeu",
    heroSubtitle: "Construis ta dream team pour les classiques 2026",
    heroDescription:
      "Stel je droomteam samen, scoor punten en maak kans op prijzen per course en in het algemeen klassement. Doe vandaag nog mee!",
    bannerTopline: "Stel jouw Classiques-team samen!",
    bannerCountdownLine: "tot de volgende course begint!",
    bannerHeadline: "Stel gratis jouw Classiques-team samen en win fantastische prijzen!",
    bannerDescription:
      "Stel je droomteam samen, scoor punten en maak kans op prijzen per course en in het algemeen klassement. Doe vandaag nog mee!",
    bannerBudgetLine: "Stel jouw €100 miljoen budget wielerteam samen voor de Classiques!",
    cards: [
      {
        id: 1,
        title: "Deviens directeur sportif",
        description: "Construis ton équipe de 20 coureurs. Attention : maximum 4 coureurs de la même équipe",
      },
      {
        id: 2,
        title: "Marque des points",
        description: "Les 20 premiers de chaque course rapportent des points. Une victoire dans les courses les plus prestigieuses donne plus de points!",
      },
      {
        id: 3,
        title: "Utilise ton bus et les transferts",
        description: "Sélectionne les bons coureurs dans ton équipe pour les courses du concours. Réalise des transferts intelligents durant la compétition",
      },
      {
        id: 4,
        title: "Défie tes amis",
        description: "Crée ou rejoins une ligue pour défier tes amis et vivre l'expérience à fond.",
      },
    ],
  },
};

export const getCompetitionCopy = (competitionFeed?: string): CompetitionCopy => {
  const normalized = (competitionFeed || "").toUpperCase() as CompetitionFeed;
  return COMPETITION_COPY[normalized] ?? COMPETITION_COPY.OCNC;
};
